<script>
    import LPButtons from "./LPButtons.svelte";
    import WPNSelector from "../Misc/WPNSelector.svelte";
    import browseOpts from "../../Stores/browseOptionsStore.js";

    export let searchCat;
    export let actions = [];

    $: optionsSelectedDD1 = $browseOpts[searchCat.name].dd1;
    $: optionsSelectedDD2 = $browseOpts[searchCat.name].dd2;

</script>

<div class="options-view">
    <div id="lp-options">
        <!-- Dropdown 1 -->
        <WPNSelector
            selectorOptions={browseOpts.dropdownOptions(searchCat.name).dd1}
            selectorName="dd1"
            selected={optionsSelectedDD1}
            on:selector-changed
        />
        <!-- Dropdown 2 -->
        <WPNSelector
            selectorOptions={browseOpts.dropdownOptions(searchCat.name).dd2}
            selectorName="dd2"
            selected={optionsSelectedDD2}
            on:selector-changed
        />
    </div>
    {#if actions.length > 0}
        <LPButtons
            {actions}
            on:export
            on:create
        />
    {/if}
</div>

<style>
    .options-view {
        display: flex;
        align-content: center;
        background-color: rgb(240, 240, 240);
        padding: 0.5rem;
        margin: auto;
    }
    #lp-options {
        text-align: center;
        margin: auto;
    }
</style>
